export default "__VITE_PUBLIC_ASSET__3a952754__"